import { render } from "./Footer.vue?vue&type=template&id=275d7dea&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=275d7dea&scoped=true&lang=css"

import exportComponent from "/Users/raulbajmuhametov/work/vue/grany/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275d7dea"]])

export default __exports__